var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _VerticalDotLine = _interopRequireDefault(require("./VerticalDotLine"));
var _jsxRuntime = require("react/jsx-runtime");
var ProgressChartLabels = function ProgressChartLabels(_ref) {
  var _ref$labels = _ref.labels,
    labels = _ref$labels === void 0 ? [] : _ref$labels,
    max = _ref.max;
  var styles = (0, _styles.useStyles)();
  var _computeLabelPosition = function _computeLabelPosition(value) {
    var width = value / max * 100;
    return width;
  };
  var sortedLabels = labels.sort(function (a, b) {
    return a.value - b.value;
  });
  return (0, _jsxRuntime.jsx)(_reactNative.View, {
    style: styles.labelsContainer,
    children: sortedLabels.map(function (item, index) {
      var labelPosition = _computeLabelPosition(item.value);
      var isOddIndex = index % 2 === 1;
      var cherryLineLength = 14;
      if (index === 1 || index === 2) {
        cherryLineLength = 29;
      }
      var containerStyles = Object.assign({}, styles.labelContainer, {
        left: "".concat(labelPosition, "%"),
        top: isOddIndex ? 0 : undefined,
        bottom: isOddIndex ? undefined : 22,
        flexDirection: isOddIndex ? 'column' : 'column-reverse'
      });
      if (Math.abs(item.value - max) <= 100) {
        containerStyles = Object.assign({}, containerStyles, {
          left: '100%'
        });
      }
      var leftValue;
      if (item.label === 'Target' && item.value === 0) {
        leftValue = 0;
      } else if (Math.abs((max - item.value) / 1000) <= 1000 && item.label !== 'Target') {
        leftValue = '-80%';
      } else {
        leftValue = '-50%';
      }
      var labelTextStyles = Object.assign({}, styles.labelText, {
        left: leftValue
      });
      return (0, _jsxRuntime.jsxs)(_reactNative.View, {
        style: containerStyles,
        children: [(0, _jsxRuntime.jsx)(_VerticalDotLine["default"], {
          styles: styles.innerMarker,
          testID: "".concat(item.label, "-inner-marker")
        }), (0, _jsxRuntime.jsx)(_VerticalDotLine["default"], {
          styles: styles.outerMarker,
          lineLength: cherryLineLength,
          testID: "".concat(item.label, "-outer-marker")
        }), (0, _jsxRuntime.jsx)(_reactNative.Text, {
          style: labelTextStyles,
          children: item.label
        })]
      }, index);
    })
  });
};
var _default = exports["default"] = ProgressChartLabels;